import React, { useState } from "react";
import Layout from "../../components/layout/Layout";
import Services from "./components/Services";
import useSourceLogic from "./useSourcesLogic";
import { AddCardUser } from "../Users/Users";
import { Dialog } from "@mui/material";
import { CloseSquare } from "iconsax-react";
import { Field, Formik, Form } from "formik";
import useToggleModal from "../../hooks/utils/useToggleModal";
import { toast } from "react-toastify";
import SourcesTab from "./components/SourcesTab";

function Sources() {
  const { serviceList, sourceList } = useSourceLogic();
  const { modalState, toggleModalState } = useToggleModal();
  const [activeTab, setActiveTab] = useState<"service" | "source">("service");
  return (
    <Layout pageName="Sources">
      <section className="mt-4">
        {/* Tabs */}
        <div className=" mb-4">
          <div className="join gap-6 border border-[#CDD0D7] p-2 px-4">
            <button
              className={
                activeTab === "service" ? `underline font-semibold` : ""
              }
              onClick={() => setActiveTab("service")}
            >
              Service
            </button>
            <button
              className={
                activeTab === "source" ? `underline font-semibold` : ""
              }
              onClick={() => setActiveTab("source")}
            >
              Sources
            </button>
          </div>
        </div>

        {activeTab === "service" ? (
          <Services data={serviceList.data} />
        ) : (
          <SourcesTab data={sourceList.data} />
        )}
      </section>
    </Layout>
  );
}

export default Sources;
